// "Inadimplência da empresa" nas telas da equipe (Cobrança, Pós-venda): a mesma conta e a
// mesma meta da tela da Gestão do Financeiro — regra do plano de bônus, foto de hoje.
import { useMemo } from 'react';
import { useFinanceiroDashboardData } from '../Dashboard/PainelExecutivo/sections/financeiro/useFinanceiroDashboardData';
import { useKpisDepartamento } from '../Dashboard/PainelExecutivo/sections/ceo/useCeoDados';
import { useMetasMensais } from '../Dashboard/PainelExecutivo/sections/metas/useMetasMensais';
import {
  META_INADIMPLENCIA_BONUS, inadimplenciaRegraBonus, kpiAutomatico, type ContextoKpis, type InadimplenciaBonus,
} from '../../src/lib/dashboard/kpisAutomaticos';
import { formatarValorKpi } from '../../src/lib/dashboard/kpisDepartamento';
import { rotuloDoMes } from '../../src/lib/dashboard/metasMensais';
import { avaliarKpi } from '../../src/lib/visaoGeral/diretoria';

export function useInadimplenciaDaEmpresa(): {
  inadimplencia: InadimplenciaBonus | null;
  meta: { texto: string; atingido: number | null } | undefined;
} {
  const fin = useFinanceiroDashboardData();
  const { kpis: kpisSalvos } = useKpisDepartamento();
  const { metas: metasMensais } = useMetasMensais();
  const temFaturas = fin.dados.length > 0;

  const inadimplencia = useMemo(() => (temFaturas ? inadimplenciaRegraBonus(fin.dados, new Date()) : null), [fin.dados, temFaturas]);
  const meta = useMemo(() => {
    const def = kpiAutomatico('fin_inadimplencia_bonus');
    if (!def) return undefined;
    const ctx: ContextoKpis = {
      hoje: new Date(), faturas: temFaturas ? fin.dados : null, parteVigor: null, metaFaturamentoUsinas: 0,
      comercial: null, marketing: null, geracao: null, paradas: null, energia: null, chamados: null,
    };
    const salvo = kpisSalvos.find(k => k.calculo_automatico === 'fin_inadimplencia_bonus' && k.status === 'validado');
    const k = avaliarKpi({ ...def, metaSugerida: () => META_INADIMPLENCIA_BONUS }, ctx, salvo, metasMensais);
    if (!k || k.carregando || k.meta <= 0) return undefined;
    const rotulo = k.origemMeta === 'mes' ? `meta de ${rotuloDoMes(k.mesMeta)}` : k.origemMeta === 'sugerida' ? 'meta do plano de bônus' : 'meta';
    return { texto: `${rotulo}: até ${formatarValorKpi(k.meta, k.unidade)}`, atingido: k.atingimento };
  }, [fin.dados, temFaturas, kpisSalvos, metasMensais]);

  return { inadimplencia, meta };
}
